var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V3.99998H22L18 0Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8V4H18L22 8Z",
    fill: "#CBD5E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#F43F5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73828 18H5.74609V16.1367H6.98828C8.13281 16.1367 8.90625 15.3789 8.90625 14.2539V14.2461C8.90625 13.1172 8.13281 12.3633 6.98828 12.3633H4.73828V18ZM6.74219 13.1875C7.46484 13.1875 7.88672 13.5742 7.88672 14.25V14.2578C7.88672 14.9336 7.46484 15.3242 6.74219 15.3242H5.74609V13.1875H6.74219ZM10.0195 18H12.1328C13.8203 18 14.7852 16.9648 14.7852 15.1602V15.1523C14.7852 13.3867 13.8086 12.3633 12.1328 12.3633H10.0195V18ZM11.0273 17.1523V13.2109H12C13.1055 13.2109 13.7578 13.9297 13.7578 15.168V15.1758C13.7578 16.4414 13.1211 17.1523 12 17.1523H11.0273ZM15.9414 18H16.9492V15.6992H19.3125V14.8789H16.9492V13.2109H19.5352V12.3633H15.9414V18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.75555ee197750a42d2e568f7ae5889d4.svg";
export { ForwardRef as ReactComponent };